import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { RentalAgreementStatusEnum } from '../enums/rental-agreement-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function rentalAgreementStatusToColor(
	status: RentalAgreementStatusEnum,
): string {
	switch (status) {
		case RentalAgreementStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case RentalAgreementStatusEnum.IN_PROGRESS:
			return RecordColorEnum.GREEN;

		case RentalAgreementStatusEnum.COMPLETED:
			return RecordColorEnum.BLUE;

		case RentalAgreementStatusEnum.CANCELLED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
